'use strict';

/**
 * Message that requires from-peer to initiate a WebRTC connection with to
 * to-peer.
 */
class MConnectTo {
    /**
     * @param {string} from The identifier of the peer that should initiate the
     * WebRTC connection.
     * @param {string} to The identifier of the peer that should accept the
     * WebRTC connection.
     */
    constructor (from, to) {
        this.from = from;
        this.to = to;
        this.type = 'MConnectTo';
    };
};

module.exports = MConnectTo;
